<template>
  <v-card
    class="elevation-2 mx-3 mb-4 rounded-lg"
    outlined
    max-height="230px"
    height="100%"
  >
    <!-- Badge Destacado -->
    <v-btn
      icon
      absolute
      top
      small
      right
    >
      <v-icon color="red" large v-show="app.destacado != 0">
        mdi-heart-circle
      </v-icon>
    </v-btn>

    <v-card-title class="subtitle-2 font-weight-bold pb-0 pt-2">
      {{ getTitulo(app.nombre) }}
    </v-card-title>
    
    <v-card-subtitle class="caption pt-4" v-html="getSubtitulo(app.descripcion)"></v-card-subtitle>

    <v-card-text class="pa-0">
      <v-row no-gutters align="center" justify="center" class="fill-height">
        
        <!-- Columna Imagen -->
        <v-col cols="6" class="d-flex justify-center align-center pl-4">
          <v-avatar
            size="150"
            tile
            rounded="0"
          >
            <v-img 
              :src="getImageUrl(app.imagen)" 
              :lazy-src="getImageUrl(app.imagen)"
              contain
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </v-col>

        <!-- Columna Info y Acciones -->
        <v-col cols="6" class="d-flex flex-column justify-space-between pr-2 pb-2">
          
          <!-- Precios -->
          <div class="text-right">
            <div class="title font-weight-bold primary--text">
              ${{ app.valor | numeral('0,0') }}
            </div>
            
            <div v-if="app.valor_ant > 0" class="caption text-decoration-line-through red--text mt-1">
              Normal ${{ app.valor_ant | numeral('0,0') }}
            </div>
            <div v-else class="caption pa-2">
              &nbsp;
            </div>
          </div>

          <!-- Estado -->
          <div class="text-right mt-2">
            <v-chip
              :color="app.estado == 1 ? 'green' : 'red'"
              dark
              x-small
            >
              {{ getEstado(app.estado) }}
            </v-chip>
          </div>

          <!-- Botón Ver Más -->
          <v-btn 
            :color="botonVerMas" 
            outlined
            small
            block
            class="mt-2"
            :disabled="app.estado == 0"
            @click="leerMas(app)"
          >
            Ver más 
          </v-btn>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['app'],
  methods: {
    getTitulo(val) {
      if (!val) return '';
      return val.substr(0, 30);
    },
    getSubtitulo(val) {
      if (!val) return '...';
      var demo = val.replace(/(&nbsp;|<([^>]+)>)/ig, ' ');
      return demo.substring(0, 30) + " ...";
    },
    getEstado(val) {
      return val == 0 ? "Agotado" : "Disponible";
    },
    leerMas(item) {
      this.$emit('leer-mas', item)
    },
  }
}
</script>

<style scoped>
/* Ajustes menores si son necesarios para la altura fija */
.v-avatar {
  overflow: visible;
}
</style>